import React from 'react'
import { useLocation } from 'react-router-dom'

// material-ui
import { Grid, Typography, Box } from '@mui/material'

// third-party
import { FormattedMessage } from 'react-intl'

// project import
import LinksStatus from 'components/common/LinksStatus'
import { PAGE_TITLES } from 'consts/pageTitles'
import UserPortfoliosSelect from './UserPortfoliosSelect'

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const location = useLocation()

  const pageTitleId = PAGE_TITLES[location.pathname] || 'dashboard'

  const getCustomTitle = () => {
    if (location.pathname === '/operations/reconciliation') {
      return PAGE_TITLES['/operations/reconciliation']
    }
    // Handle settlement routes with dynamic parameters
    if (location.pathname.startsWith('/operations/settlement')) {
      return PAGE_TITLES['/operations/settlement']
    }
    // Handle tranche schedule dynamic route
    if (location.pathname.match(/^\/lms\/tranches\/.+/)) {
      return PAGE_TITLES['/lms/tranches']
    }
    return null
  }

  const customTitle = getCustomTitle()

  return (
    <Grid container justifyContent={'space-between'} alignItems={'center'}>
      {/* Page Title */}
      <Grid item>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h4">
            <FormattedMessage id={customTitle || pageTitleId} />
          </Typography>
        </Box>
      </Grid>

      {/* Right side content */}
      <Grid item>
        <Grid container alignItems={'center'} columnSpacing={2}>
          <Grid item>
            <LinksStatus />
          </Grid>
          <Grid item>
            <UserPortfoliosSelect />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HeaderContent
